<template>
  <div class="actions-block">
    <div class="actions-block-header" :id="block_header_id" @click="showHideBlock(block)">
      <div :id="triangle_id" class="triangle"></div>
      <div class="block-title">{{ name }}</div>
    </div>
    <div class="actions-block-body" :id="block_body_id" data-collapsed="false">
      <ContainerAction
          v-for="action in actions"
          v-bind:key="action.id"
          v-bind:id="action.id"
          v-bind:name="action.name"
          v-bind:status="action.status"
      ></ContainerAction>
    </div>
  </div>



</template>

<script>
import { mapGetters } from 'vuex'
import ContainerAction from '@/components/containerViews/containerActionsComponents/ContainerAction'

export default {
  name: 'ContainerActionsBlock',
  components: {
    ContainerAction
  },
  props: ['block', 'name', 'actions'],
  data(){
    return {
      block_header_id: '',
      block_body_id: '',
      triangle_id: '',
    }
  },
  computed: {
    ...mapGetters(["view_role"]),
    ...mapGetters("container",{
      container_id: 'container_id',
      container_status: 'container_status',
      action_list: 'action_list'
    }) 
  },
  beforeMount () {   
    this.block_header_id = 'block-' + this.block + '-header'
    this.triangle_id = 'triangle-' + this.block
    this.block_body_id = 'block-' + this.block + '-body'
  },
  mounted () {
  },
  methods: {
    showHideBlock: function(block){
      var triangle = document.getElementById("triangle-" + block)
      var body = document.getElementById("block-" + block + "-body")
      triangle.classList.toggle("collapse")
      //body.classList.toggle("collapse")
      
      var isCollapsed = body.getAttribute('data-collapsed') === 'true';       
      if(isCollapsed) {
        this.expandBlock(body)
      } else {
        this.collapseBlock(body)
      }
    },
    collapseBlock: function(element) {
      // get the height of the element's inner content, regardless of its actual size
      var sectionHeight = element.scrollHeight;
      
      // temporarily disable all css transitions
      var elementTransition = element.style.transition;
      element.style.transition = '';
      
      // on the next frame (as soon as the previous style change has taken effect),
      // explicitly set the element's height to its current pixel height, so we 
      // aren't transitioning out of 'auto'
      requestAnimationFrame(function() {
        element.style.height = sectionHeight + 'px';
        element.style.transition = elementTransition;
        
        // on the next frame (as soon as the previous style change has taken effect),
        // have the element transition to height: 0
        requestAnimationFrame(function() {
          element.style.height = 0 + 'px';
        });
      });
      
      // mark the section as "currently collapsed"
      element.setAttribute('data-collapsed', 'true');
    },

    expandBlock: function(element) {
      // get the height of the element's inner content, regardless of its actual size
      var sectionHeight = element.scrollHeight;
      
      // have the element transition to the height of its inner content
      element.style.height = sectionHeight + 'px';

      // when the next css transition finishes (which should be the one we just triggered)
      /*element.addEventListener('transitionend', function(e) {
        // remove this event listener so it only gets triggered once
        element.removeEventListener('transitionend', arguments.callee);
        
        // remove "height" from the element's inline styles, so it can return to its initial value
        element.style.height = null;
      });*/
      
      // mark the section as "currently not collapsed"
      element.setAttribute('data-collapsed', 'false');
    },
    setBlockHeights: function(block){
      var body = document.getElementById("block-" + block + "-body")
      // get the height of the element's inner content, regardless of its actual size
      var sectionHeight = body.scrollHeight;
      
      // have the element transition to the height of its inner content
      body.style.height = sectionHeight + 'px';     
    }
  }
}
</script>

<style lang= "scss" scoped>
.actions-block-header {
  height: 30px;
  width: 100%;
  background-color: #eeeeee;
  border: 1px solid lightgray;
  box-shadow: 0px 3px 6px rgba(0,0,0,0.3);
  position: relative;
  z-index: 10;
  cursor: pointer;
  padding: 0 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.block-title {
  flex: 1;
  margin-top: -2px;
  font-size: 0.95em;
  margin-left: 8px;
}
.actions-block-body {
  overflow: hidden;
}

#block-1-body, #block-2-body, #block-3-body, #block-4-body, #block-5-body, #block-6-body, #block-7-body, #block-8-body, .triangle {      
  -webkit-transition: .25s ease-in-out;
  -moz-transition: .25s ease-in-out;
  -o-transition: .25s ease-in-out;
  transition: .25s ease-in-out;
}
.triangle {
  width: 0;
  height: 0;
  border-top: 5px solid transparent;
  border-left: 10px solid #303F37;
  border-bottom: 5px solid transparent;
  position: relative;
  top: 0px;
  margin-right: 6px;

  transform: rotate(90deg);
  -webkit-transform: rotate(90deg);
}
#triangle-1.collapse, #triangle-2.collapse, #triangle-3.collapse, #triangle-4.collapse, #triangle-5.collapse, #triangle-6.collapse, #triangle-7.collapse, #triangle-8.collapse {
  transform: rotate(0deg);
  -webkit-transform: rotate(0deg);
  display: block;
}

</style>
